import React ,{useRef, useState}from 'react'
import style from '../stylees/signin.module.css'
import { useAuth } from '../contextApi/Auth_context';
import { Navigate, redirect,useNavigate } from 'react-router-dom';
import Header from './Header';
export default function SignIn() {
  const[message, setMessage] = useState("");
  const[Button_display, setButton_display] = useState("");
  const userNameRef=useRef()
  const passwordRef=useRef()
  const navigator=useNavigate()
  const { login } = useAuth();
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(userNameRef.current.value, passwordRef.current.value);
    navigator('/',{replace:true})
    } catch (error) {
      console.error("signin failed:", error.message);
      setMessage("Error signing in. Please try again.");
    }
  };
  return (
    <>
    
         <div className={`${style.body}`}>
         <Header></Header>
      <div className={`container p-4`}>
  
        <div
          className={`${style.foir} container col-md-6 col-lg-6 col-sm-12 py-3 bg-white rounded-4 `}
        >
          <h2 className="text-center mb-4">Log in </h2>
          <form className="row g-3 col-md-10 mx-auto" onSubmit={handleSubmit}>
            {/* user_name input */}
            <div className="col-md-12">
              <label htmlFor="user" className="form-label">
              Email
              </label>
              <input
                type="email"
                className={`form-control ${style.inputChange}`}
                name="user_email"
                id="user"
                placeholder="Enter your email"
                aria-describedby="inputGroupPrepend2"
                required
                ref={userNameRef}
                onInvalid={(e) =>
                  e.target.setCustomValidity("برجاء ادخال اسم  المستخدم")
                }
                onInput={(e) => e.target.setCustomValidity("")}
  
              />
            </div>
            {/* Password*/}
            <div className="col-md-12">
              <label htmlFor="pass" className="form-label">
               
               password
              </label>
              <input
                type="password"
                className={`form-control ${style.inputChange}`}
                name="password"
                id="pass"
                placeholder="Password"
                aria-describedby="inputGroupPrepend2"
                required
                ref={passwordRef}
                onInvalid={(e) =>
                  e.target.setCustomValidity("Enter password")
                }
                onInput={(e) => e.target.setCustomValidity("")}
                
              />
            </div>
 {/*display error mesage  */}
 {message != "" ? (
              <div className={`alert-danger alert  text-center`} role="alert">
                {message}
              </div>
            ) : null}
            {/* submtion  */}
            <div className="col-12  text-center">
              <button className={`${Button_display} btn btn-dark`}>
                Sign in
              </button>
            </div>
          </form>
          </div>
          </div>
          </div>
          </>
  )
}
